import {
  COMPLAINS,
  COMPLAINSDETAILS,
  COMPLAINS_SUCCESS,
  COMPLAINSDETAILS_SUCCESS,
  COMPLAINS_ERROR,
  COMPLAINSDETAILS_ERROR
} from './Complains.actions'

const initialState = {
  data: { total: {}, categories: [] },
  details: [],
  fetching: false,
  fetched: false,
  error: null
}

/**
 * Complain's reducer.
 */
const complainsReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case COMPLAINS: {
      return { ...state, fetching: true }
    }
    case COMPLAINS_SUCCESS: {
      return { ...state, data: payload, fetching: false, fetched: true }
    }
    case COMPLAINS_ERROR: {
      return { ...state, error: payload.error }
    }
    case COMPLAINSDETAILS: {
      return { ...state, fetching: true }
    }
    case COMPLAINSDETAILS_SUCCESS: {
      return { ...state, details: payload, fetching: false, fetched: true }
    }
    case COMPLAINSDETAILS_ERROR: {
      return { ...state, error: payload.error }
    }
    default: {
      return state
    }
  }
}

export default complainsReducer
